// extracted by mini-css-extract-plugin
export default {"ContainerLoad":"Load_ContainerLoad__qGuZB","Load":"Load_Load__fd2-H","is-rotating":"Load_is-rotating__Zzet5"};